import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export { mockCurrentUser, type CurrentUser } from "./currentUser";
export { type ClientRecord } from "./mockClients";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateForDisplay(value: string): string {
  if (!value) {
    return "";
  }

  const [year, month, day] = value.split("-");

  if (!year || !month || !day) {
    return value;
  }

  const months = [
    "Gen",
    "Feb",
    "Mar",
    "Apr",
    "Mag",
    "Giu",
    "Lug",
    "Ago",
    "Set",
    "Ott",
    "Nov",
    "Dic",
  ];

  const monthLabel = months[Number(month) - 1];

  if (!monthLabel) {
    return value;
  }

  return `${Number(day)} ${monthLabel} ${year}`;
}

export function isDateWithinRange(
  value: string,
  startDate?: string,
  endDate?: string,
): boolean {
  if (!value) {
    return false;
  }

  if (startDate && value < startDate) {
    return false;
  }

  if (endDate && value > endDate) {
    return false;
  }

  return true;
}

export {
  extractCustomerTagValue,
  extractCashDiscountPercent,
  extractCashDiscountTag,
  formatTotal,
  calculateDiscountedPrice,
  formatItemOptions,
  parseItemOptions,
  saveOrder,
  getOrders,
  getOrderById,
  type OrderItem,
  type OrderRecord,
} from "./orders";

export * from "./orders";
export * from "./api";
export * from "./auth";
export * from "./errorTracking";
export * from "./availability";

